const PAXSHOTEL_FETCH = (state, PaxsHotel) => {
  state.PaxsHotel = PaxsHotel
}

const PAXSHOTEL_ROOMS_FETCH = (state, PaxsHotelRooms) => {
  state.PaxsHotelRooms = PaxsHotelRooms
}

export default {
  PAXSHOTEL_FETCH,
  PAXSHOTEL_ROOMS_FETCH
}
